// Tom Select initialization for Reports Equipment & Method Specific Variables tabs ONLY
// This file handles Tom Select dropdowns in Reports section while keeping Select2 everywhere else

// Tom Select is loaded via CDN script tag in layout (see application.html.erb)
// This avoids Babel/Webpack transpilation issues with older Rails setup
// The TomSelect class is available globally after CDN script loads

/**
 * Initialize Tom Select on specific dropdowns
 * @param {string} selector - CSS selector for dropdowns to initialize (default: '.tom-select-dropdown')
 */
function initializeTomSelect(selector = '.tom-select-dropdown') {
  // Wait for TomSelect to be available from CDN
  if (typeof TomSelect === 'undefined') {
    console.warn('TomSelect not loaded yet, will retry on next page load');
    return;
  }

  const elements = document.querySelectorAll(selector);

  elements.forEach((el) => {
    // Skip if already initialized
    if (el.tomselect) {
      return;
    }

    // Skip if element is hidden or not in DOM
    if (!el.offsetParent && el.style.display === 'none') {
      return;
    }

    new TomSelect(el, {
      allowEmptyOption: true,
      create: false,
      sortField: {
        field: "text",
        direction: "asc"
      },
      plugins: {
        clear_button: {
          title: 'Clear selection',
        }
      },
      render: {
        no_results: function(data, escape) {
          return '<div class="no-results">No results found</div>';
        }
      },
      // Disable search for consistency with previous Select2 behavior
      searchField: [],
      // Custom styling via tom-select-custom.css
      dropdownClass: 'ts-dropdown'
    });
  });
}

/**
 * Destroy all Tom Select instances
 * Used before Turbolinks caches the page
 */
function destroyTomSelect() {
  document.querySelectorAll('.tom-select-dropdown').forEach((el) => {
    if (el.tomselect) {
      el.tomselect.destroy();
    }
  });
}

// Expose globally for AJAX reinitialization in .js.erb files
window.initializeTomSelect = initializeTomSelect;
window.destroyTomSelect = destroyTomSelect;

// Initialize on Turbolinks load (when page is fully loaded/cached page is restored)
document.addEventListener('turbolinks:load', () => {
  initializeTomSelect();
});

// Cleanup before Turbolinks caches the page
// This prevents issues when navigating back/forward
document.addEventListener('turbolinks:before-cache', () => {
  destroyTomSelect();
});

// Also initialize on DOMContentLoaded as fallback for non-Turbolinks navigation
document.addEventListener('DOMContentLoaded', () => {
  initializeTomSelect();
});
